import React from 'react'

export function RecordContent({ children }: { children: React.ReactNode }) {
  return (
    <div id='a11y-record-content' className='c-record-content'>
      {children}
    </div>
  )
}
